import script from "./phone.vue?vue&type=script&setup=true&lang=js"
export * from "./phone.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__